<template>
  <div>
    <div class="awardsList" v-if="awardsList">
      <AwardItem
        v-for="awardData in awardsList"
        :awardData="awardData"
        :key="awardData.id"
      />
      <div class="noMore" v-if="awardsList.length">
        没有更多了~
      </div>
    </div>
    <div class="empty" v-if="awardsList && !awardsList.length">
      <div class="icon"></div>
      <div>您还没有任何奖励哦～</div>
    </div>
  </div>
</template>

<script>
import AwardItem from './AwardItem';
import { mapState } from 'vuex';

export default {
  components: { AwardItem },
  computed: {
    ...mapState('app/myAwards', {
      awardsList: state => state.awardsList
    })
  }
};
</script>

<style lang="less" scoped>
.awardsList {
  width: 100%;
  border-radius: 16px;
  background-color: #fff;

  .noMore {
    margin: 30px 0;
    padding-bottom: 30px;
    text-align: center;
  }
}
.empty {
  margin-top: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .icon {
    margin-bottom: 107px;
    width: 287px;
    height: 185px;
    background: center / cover no-repeat url('../assets/images/empty.png');
  }
}
</style>
